import React from "react";
import { Route, Redirect } from "react-router-dom";

const CaseSensitiveRoute = ({ path, component: Component, ...rest }) => {
  return (
    <Route
      path={path}
      {...rest}
      render={({ location }) =>
        location.pathname === path ? (
          <Component />
        ) : (
          <Redirect to="/404" />
        )
      }
    />
  );
};

export default CaseSensitiveRoute;